import React from 'react';
import { NextContext } from 'next';
import Utils from '../../libs/utils';
import LayoutActionDispatcher from '../../modules/commons/LayoutActionDispatcher';
import TopicActionDispatcher from '../../modules/topics/ActionDispatcher';
import * as Pager from '../../domain/Pager';
import TopicListContainer from '../../components/topic/list/Container';
import TopicListPagerContainer from '../../components/topic/pager/Container';
import CategoryListContainer from '../../components/category/list/Container';
import SearchContainer from '../../components/top/search/Container';
import HEAD from 'next/head';

class TopicList extends React.PureComponent {
  public static async getInitialProps(ctx: NextContext) {
    const { store, query, pathname, res } = ctx;
    const categoryCode = Utils.parseInt(query.category_code);
    const sort = Utils.parseInt(query.sort) || 1;
    const page = Utils.parseInt(query.page) || 1;

    // categoryCode = 0 は全トピック一覧扱い
    const category = store.getState().entities.categories.getEntity(categoryCode);
    if (categoryCode !== 0 && category.isEmpty()) {
      // SEO 対策 - SSR 時のみ 404 ステータスコードを返すようにする
      if (res) {
        res.statusCode = 404;
      }
      const err = new Error() as any;
      err.code = 'ENOENT';
      throw err;
    }

    const session = store.getState().commons.session;
    const action = new TopicActionDispatcher(store.dispatch, session);
    const pager = Pager.Value.fromJS({ page, filter: { sort, categoryCode } });
    const entityList = await action.fetchList(pager);

    const totalCount = entityList.totalCount;
    const pageTitle = category.name ? `${category.name}` : '全トピック一覧';
    const title = `${pageTitle} ${totalCount}件：ラウンジ【ナース専科】`;

    // /topic/list/1/ と 末尾に / が含まれる場合があるので pathname と categoryCode から path を算出する
    const asPath = categoryCode === 0 ? pathname : `${pathname}/${category.code}`;

    const breadcrumbData = [{ path: 'category', label: pageTitle }];
    if (page > 1) {
      breadcrumbData.push({ path: '', label: `${page}ページ目` });
    }

    const layoutAction = new LayoutActionDispatcher(store.dispatch);
    layoutAction.settingLayout({
      header: {
        pageTitle,
        isNewHeader: true,
      },
      breadcrumb: {
        data: breadcrumbData,
        params: {
          categoryCode,
        },
      },
      footer: {
        showPostButton: true,
      },
      seo: {
        asPath,
        pager: store.getState().topics.list,
        title: page <= 1 ? title : `${page}ページ目：${title}`,
        description: `${pageTitle}のページです。全${totalCount}件のトピックがあります。`,
        canonical: page <= 1 ? asPath : `${asPath}?page=${page}`,
      },
    });
  }

  public render(): React.ReactNode {
    return (
      <main className="p-2 lg:w-7/12 lg:mt-1 lg:ml-auto lg:mr-3">
        <HEAD>
          <link href="https://cdn-nurse-senka-assets.nurse-senka.jp/css/tailwind.min.css" rel="stylesheet" />
          <link href="https://use.fontawesome.com/releases/v5.0.6/css/all.css" rel="stylesheet" />
        </HEAD>
        <TopicListContainer />
        <TopicListPagerContainer />
        <CategoryListContainer />
        <SearchContainer />
      </main>
    );
  }
}

export default TopicList;
